import { render, staticRenderFns } from "./scroll-wrapper.vue?vue&type=template&id=2949733e&scoped=true&"
import script from "./scroll-wrapper.vue?vue&type=script&lang=js&"
export * from "./scroll-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./scroll-wrapper.vue?vue&type=style&index=0&id=2949733e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2949733e",
  null
  
)

export default component.exports